import api, { QUALIFICATIONS } from "./api";

export const fetchQualificationLevels = async () => {
  return await api.get(`${QUALIFICATIONS}
  `);
};
